"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useList = function useList(initialList) {
  if (initialList === void 0) {
    initialList = [];
  }

  var _a = react_1.useState(initialList),
      list = _a[0],
      set = _a[1];

  return [list, {
    set: set,
    updateAt: function updateAt(index, entry) {
      return set(list.slice(0, index).concat([entry], list.slice(index + 1)));
    },
    remove: function remove(index) {
      return set(list.slice(0, index).concat(list.slice(index + 1)));
    },
    push: function push(entry) {
      return set(list.concat([entry]));
    },
    filter: function filter(fn) {
      return set(list.filter(fn));
    },
    sort: function sort(fn) {
      return set(list.slice().sort(fn));
    }
  }];
};

exports.default = useList;